import { computed, WritableComputedRef, nextTick } from 'vue'
import { scrollTo } from '@/util/useScrollTo'
/**
 *
 * @param props
 * @param emits
 * @param fn set 回调
 * @returns
 */
export default function (props: any, emits: any, fn?: () => any) {
  const currentPage:WritableComputedRef<number> = computed({
    get () {
      return props.pageData.page
    },
    set (page: number) {
      const { limit } = props.pageData
      emits('update:page-data', { page, limit })
      scrollTo(0, 800)
      nextTick(() => {
        fn && fn()
      })
    }
  })
  const pageSize:WritableComputedRef<number> = computed({
    get () {
      return props.pageData.limit
    },
    set (limit: number) {
      const { page } = props.pageData
      // 切换条数页面置为1
      emits('update:page-data', { page: 1, limit })
      scrollTo(0, 800)
      nextTick(() => {
        fn && fn()
      })
    }
  })
  return {
    currentPage,
    pageSize
  }
}
